import { Component } from 'react'
import * as Sentry from '@sentry/browser'

class SentryWrapper extends Component {
  // Catches every crash error, and report to sentry
  // (Which was initialized on SentryHandler.web.js)
  componentDidCatch (error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setTag('type', 'root')
      scope.setLevel(Sentry.Severity.Error)
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  render () {
    return this.props.children
  }
}

export default SentryWrapper



// WEBPACK FOOTER //
// ./src/components/globals/SentryWrapper.web.js